import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';

function AdminSignup() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuth = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        navigate('/AdminMain');
      }
    };
    handleAuth();
  }, [navigate]);

  const handleSignup = async (e) => {
    e.preventDefault();
    setMessage('');

    try {
      const { data: signUpData, error: signUpError } = await supabase.auth.signUp({
        email,
        password,
        options: {
          data: {
            full_name: fullName
          }
        }
      });

      if (signUpError) throw signUpError;

      setMessage('✅ Inscription réussie ! Redirection vers la page de connexion...');
      
      setTimeout(() => {
        navigate('/Login');
      }, 2000);

    } catch (error) {
      console.error('Erreur inscription:', error);
      setMessage(error.message || 'Une erreur est survenue lors de l\'inscription');
    }
  };

  return (
    <div className="container-scroller">
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="row w-100 m-0">
          <div className="content-wrapper full-page-wrapper d-flex align-items-center auth login-bg">
            <div className="card col-lg-4 mx-auto">
              <div className="card-body px-5 py-5">
                <h3 className="card-title text-left mb-3">Inscription</h3>
                <form onSubmit={handleSignup}>
                  <div className="form-group">
                    <label>Nom et prénom *</label>
                    <input
                      type="text"
                      className="form-control p_input"
                      value={fullName}
                      placeholder="Nom et prénom" 
                      onChange={(e) => setFullName(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Email *</label>
                    <input
                      type="email"
                      className="form-control p_input"
                      value={email}
                      placeholder="Email" 
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Mot de passe *</label>
                    <input
                      type="password"
                      className="form-control p_input"
                      placeholder="Mot de passe" 
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div className="text-center">
                    <button type="submit" className="btn btn-primary btn-block enter-btn">
                      S'inscrire
                    </button>
                  </div>
                  <p className="sign-up mt-3">
                    Déjà un compte ? <a href="/Login">Se connecter</a>
                  </p>
                  <p className={`mt-2 ${
                    message && message.startsWith('Un email') 
                      ? 'text-success' 
                      : 'text-danger'
                  }`}>
                    {message}
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminSignup;


{/*function AdminSignup() {
  return null;
}
export default AdminSignup;
*/}
